const HssAchievment = () => import(/* webpackChunkName: "manager" */ './HssAchievment');
const Manage = () => import(/* webpackChunkName: "manager" */ './Manage')

export default {
    routes: [
        {
            path: '/achi/index',
            name: 'HssAchievment',
            component: HssAchievment
        },
        {
            path: '/achi/manage/:dbid',
            name: 'Manage',
            component: Manage
        }
    ]
}
